module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/dish-63793d2955a4c5e7335c68f97dad70c7.svg";